module.exports = __webpack_public_path__ + "img/out_norms_img.76252ac1.png";